(function () {
  const finance = document.getElementById('finance-calculator');
  if (!finance) return;

  const leaseMatrix   = JSON.parse(finance.dataset.leaseMatrix   || '{}');
  const financeMatrix = JSON.parse(finance.dataset.financeMatrix || '{}');
  const leaseFallback    = finance.dataset.leaseFallback    || '–';
  const financeFallback  = finance.dataset.financeFallback  || '–';
  const leaseAvailable   = finance.dataset.leaseAvailable   === '1';
  const financeAvailable = finance.dataset.financeAvailable === '1';
  const cashPrice        = finance.dataset.cashPrice        || '–';
  const labels           = JSON.parse(finance.dataset.i18n  || '{}');
  // Purchase types this vehicle offers, decided server-side (TD-119). Tabs and
  // panels exist only for these; anything else resolves to the first one.
  const available        = JSON.parse(finance.dataset.available || '[]');
  const resolveMode = (mode) => (available.includes(mode) ? mode : available[0]);

  const moneyFmt      = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
  const moneyFmtCents = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const kmFmt         = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

  const modeButtons  = finance.querySelectorAll('[data-fin-mode]');
  const modePanels   = finance.querySelectorAll('[data-fin-panel]');
  const modeResults  = finance.querySelectorAll('[data-fin-result]');

  const leaseTerm      = finance.querySelector('#leaseTerm');
  const leaseKm        = finance.querySelector('#leaseKm');
  const leaseRateBig   = finance.querySelector('#leaseRateBig');
  const leaseExtraOut  = finance.querySelector('#leaseExtraOut');
  const leaseMeta      = finance.querySelector('#leaseMeta');

  const financeTerm     = finance.querySelector('#financeTerm');
  const financeKm       = finance.querySelector('#financeKm');
  const financeRateBig  = finance.querySelector('#financeRateBig');
  const financeExtraOut = finance.querySelector('#financeExtraOut');
  const financeMeta     = finance.querySelector('#financeMeta');

  function setMode(mode) {
    modeButtons.forEach(btn => {
      const isActive = btn.dataset.finMode === mode;
      btn.classList.toggle('border-b-2',           isActive);
      btn.classList.toggle('border-autonia-orange', isActive);
      btn.classList.toggle('bg-white/10',          isActive);
      btn.classList.toggle('text-white',           isActive);
      btn.classList.toggle('font-bold',            isActive);
      btn.classList.toggle('bg-transparent',       !isActive);
      btn.classList.toggle('text-slate-300',       !isActive);
      btn.classList.toggle('font-medium',          !isActive);
    });
    modePanels.forEach(panel  => panel.classList.toggle('hidden',  panel.dataset.finPanel  !== mode));
    modeResults.forEach(card  => card.classList.toggle('hidden',   card.dataset.finResult  !== mode));

    if (mode === 'cash') {
      const cashCard = finance.querySelector('[data-fin-result="cash"]');
      if (cashCard) {
        const price = cashCard.querySelector('span');
        if (price) price.textContent = cashPrice;
      }
    }
  }

  function updateKmOptions(termEl, kmEl, matrix) {
    if (!termEl || !kmEl) return;
    const term  = termEl.value;
    const rates = (matrix[term] && matrix[term].rates) ? matrix[term].rates : {};
    const kms   = Object.keys(rates).map(Number).filter(Boolean).sort((a, b) => a - b);
    if (!kms.length) return;
    const current = parseInt(kmEl.value, 10);
    kmEl.innerHTML = '';
    kms.forEach(km => {
      const opt = document.createElement('option');
      opt.value       = String(km);
      opt.textContent = kmFmt.format(km);
      kmEl.appendChild(opt);
    });
    kmEl.value = kms.includes(current) ? String(current) : String(kms[0]);
  }

  function updateResults(config) {
    if (!config.termEl || !config.kmEl) return;
    const term    = parseInt(config.termEl.value, 10) || 0;
    const km      = parseInt(config.kmEl.value,   10) || 0;
    const rates   = (config.matrix[term] && config.matrix[term].rates) ? config.matrix[term].rates : {};
    const price   = rates && rates[km] ? parseFloat(rates[km]) : 0;
    const extra   = (config.matrix[term] && config.matrix[term].extra) ? parseFloat(config.matrix[term].extra) : 0;
    const hasRates = rates && Object.keys(rates).length > 0;

    const priceText = price ? moneyFmt.format(price) : config.fallback;
    if (config.rateBig)   config.rateBig.textContent = priceText;
    if (config.extraOut)  config.extraOut.textContent = (hasRates && extra)
      ? labels.extraKm + ': ' + moneyFmtCents.format(extra) + '/km'
      : labels.extraKm + ': –';
    if (config.meta)      config.meta.textContent = (hasRates && price && term && km)
      ? term + ' ' + labels.months + ' · ' + kmFmt.format(km) + ' ' + labels.kmPerYear
      : config.noDataLabel;
  }

  const leaseConfig = {
    termEl: leaseTerm, kmEl: leaseKm, rateBig: leaseRateBig,
    extraOut: leaseExtraOut, meta: leaseMeta,
    matrix: leaseMatrix, fallback: leaseFallback, noDataLabel: labels.noLease,
  };
  const financeConfig = {
    termEl: financeTerm, kmEl: financeKm, rateBig: financeRateBig,
    extraOut: financeExtraOut, meta: financeMeta,
    matrix: financeMatrix, fallback: financeFallback, noDataLabel: labels.noFinance,
  };

  // Update the "Anfragen" CTA link with current term/km/rate so the inquiry
  // start page receives them pre-filled as URL parameters.
  const ctaLink = finance.querySelector('a[data-inquiry-cta]');
  function updateCtaLink() {
    if (!ctaLink) return;
    const url = new URL(ctaLink.href, window.location.origin);
    const mode = finance.querySelector('[data-fin-panel]:not(.hidden)')?.dataset?.finPanel || available[0];
    // The inquiry page preselects from this parameter (TD-120); before, it
    // only ever saw the cookie value baked into the link server-side.
    if (mode) url.searchParams.set('purchase_type', mode);
    if (mode === 'lease' && leaseTerm && leaseKm) {
      const term  = parseInt(leaseTerm.value, 10);
      const km    = parseInt(leaseKm.value,   10);
      const rates = leaseMatrix[term]?.rates || {};
      const rate  = rates[km] || 0;
      url.searchParams.set('finance_term', term);
      url.searchParams.set('finance_km',   km);
      if (rate) url.searchParams.set('finance_monthly_rate', rate);
      else url.searchParams.delete('finance_monthly_rate');
    } else if (mode === 'finance' && financeTerm && financeKm) {
      const term  = parseInt(financeTerm.value, 10);
      const km    = parseInt(financeKm.value,   10);
      const rates = financeMatrix[term]?.rates || {};
      const rate  = rates[km] || 0;
      url.searchParams.set('finance_term', term);
      url.searchParams.set('finance_km',   km);
      if (rate) url.searchParams.set('finance_monthly_rate', rate);
      else url.searchParams.delete('finance_monthly_rate');
    } else {
      url.searchParams.delete('finance_term');
      url.searchParams.delete('finance_km');
      url.searchParams.delete('finance_monthly_rate');
    }
    ctaLink.href = url.toString();
  }

  modeButtons.forEach(btn => btn.addEventListener('click', () => { setMode(btn.dataset.finMode); updateCtaLink(); }));

  if (leaseTerm)   leaseTerm.addEventListener('change',   () => { updateKmOptions(leaseConfig.termEl,   leaseConfig.kmEl,   leaseConfig.matrix);   updateResults(leaseConfig);   updateCtaLink(); });
  if (leaseKm)     leaseKm.addEventListener('change',     () => { updateResults(leaseConfig);   updateCtaLink(); });
  if (financeTerm) financeTerm.addEventListener('change', () => { updateKmOptions(financeConfig.termEl, financeConfig.kmEl, financeConfig.matrix);  updateResults(financeConfig); updateCtaLink(); });
  if (financeKm)   financeKm.addEventListener('change',   () => { updateResults(financeConfig); updateCtaLink(); });

  const preferred = document.body?.className.match(/payment-(cash|lease|finance)/)?.[1] || '';
  setMode(resolveMode(preferred));

  window.addEventListener('autonia:paymentChange', (event) => {
    const value = event?.detail?.value;
    if (value) { setMode(resolveMode(value)); updateCtaLink(); }
  });

  if (leaseAvailable)   { updateKmOptions(leaseConfig.termEl,   leaseConfig.kmEl,   leaseConfig.matrix);  updateResults(leaseConfig);   }
  if (financeAvailable) { updateKmOptions(financeConfig.termEl, financeConfig.kmEl, financeConfig.matrix); updateResults(financeConfig); }
  updateCtaLink();
})();
